<p-dialog [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [(visible)]="exportLoading"
          [style]="{ width: '425px', height: '215px' }">
    <ng-template pTemplate="header">
        <span class="dialog-header">Downloading data</span>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data</div>
        <div class="mt-4 text-center">
            <p-progressSpinner styleClass="w-4rem h-4rem"
                               strokeWidth="8"
                               fill="var(--surface-ground)"
                               animationDuration=".5s" />
        </div>
    </ng-template>
</p-dialog>

<inquiry-detail-info *ngIf="isVisibleInqueryInfo"
                             [_selectedInquiry]="selectedInquiry"
                             (changedVisibleInquiryEmit)="changedVisibleInquiryInfoEmit($event)">
</inquiry-detail-info>


<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-toast></p-toast>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>
    <div class="card">
        <p-table #inquiriesGrid
                 [columns]="cols"
                 [value]="inquiries"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading"
                 [style]="{height: 'calc(80vh)'}">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-fleft ml-2">
                        <div class="head-title mt-3 ml-1 inquiry-title">Inquiries</div>
                    </div>
                    <div class="flex flex-row onboarding-head-right mr-2">
                        <xpress-calendar style="width: 200px; margin-right: 10px;" class="xpress-date-picker" [marginLeft]="'-530px'" (generateHandler)="dateFilterChange($event)">
                        </xpress-calendar>
                        <div>
                            <img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
                            <div pRipple class="btn-revenue-export" (click)="op.toggle($event)">Export</div>
                        </div>

                        <p-overlayPanel #op [style]="{width: '180px'}">
                            <ng-template pTemplate>
                                <div (click)="exportReport(exportFileType.CSV)" class="report-inquiry-top-button">CSV Report</div>
                                <div (click)="exportReport(exportFileType.Excel)" class="report-inquiry-top-button">Excel Report</div>
                                <div (click)="exportReport(exportFileType.PDF)" class="report-inquiry-top-button">PDF Report</div>
                            </ng-template>
                        </p-overlayPanel>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" [disabled]="filter.disabled" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="inquiryHeaderSearch[filter.model]"
                                       (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <input [disabled]="filter.disabled" type="number" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="inquiryHeaderSearch[filter.model]"
                                       (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <p-dropdown [disabled]="filter.disabled" [options]="filter.options" placeholder="{{filter.placeholder}}"
                                            optionLabel="name" optionValue="value" [(ngModel)]="inquiryHeaderSearch[filter.model]"
                                            (ngModelChange)="handleHeaderFilterChange($event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-inquiry>
                <tr [pSelectableRow]="inquiries">
                    <td *ngFor="let col of cols" class="ui-resizable-column" (click)="handlePopupLinkClick(inquiry)">
                        {{inquiry[col.field]}}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="inquiries && inquiries.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + inquiries.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>